<template>
  <!-- Layout público SEM menu -->
  <router-view />
</template>

<script>
export default {
  name: "PublicLayout",
};
</script>

<style scoped>
/* Aqui você pode colocar estilos globais da landing/login se quiser */
</style>
